import React from "react";
import { Link, useParams } from "react-router-dom";
import { getPostBySlug, formatPostDate } from "../data/blogPosts";
import "./BlogPostPage.css";

function renderParagraph(block, key) {
  if (typeof block === "string") {
    return <p key={key}>{block}</p>;
  }

  return (
    <p key={key}>
      {block.parts.map((part, i) =>
        part.type === "link" ? (
          <Link key={i} to={part.to} className="blog-post-inline-link">
            {part.label}
          </Link>
        ) : (
          <React.Fragment key={i}>{part.value}</React.Fragment>
        )
      )}
    </p>
  );
}

const SITE_ORIGIN = "https://www.pacewerks.com";

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return (
      <main className="blog-post-page">
        <div className="blog-post-inner">
          <h1 className="blog-post-title">Post not found</h1>
          <p className="blog-post-missing">
            We could not find that article. Browse all posts on PaceNotes.
          </p>
          <Link to="/blog" className="blog-post-back">
            ← Back to PaceNotes
          </Link>
        </div>
      </main>
    );
  }

  const postUrl = `${SITE_ORIGIN}/blog/${post.slug}`;
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.excerpt,
    datePublished: post.date,
    dateModified: post.date,
    author: {
      "@type": "Person",
      name: "David Baum",
    },
    publisher: {
      "@type": "Organization",
      name: "PaceWerks",
      url: SITE_ORIGIN,
    },
    url: postUrl,
    mainEntityOfPage: postUrl,
  };

  return (
    <main className="blog-post-page">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <article className="blog-post-inner">
        <Link to="/blog" className="blog-post-back">
          ← Back to PaceNotes
        </Link>

        <header className="blog-post-header">
          <time className="blog-post-date" dateTime={post.date}>
            {formatPostDate(post.date)}
          </time>
          <h1 className="blog-post-title">{post.title}</h1>
        </header>

        <div className="blog-post-body">
          {post.content.map((paragraph, index) =>
            renderParagraph(paragraph, index)
          )}
        </div>
      </article>
    </main>
  );
}
